import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

export const resetTraces = async <T extends Action<ACTION_TYPE.RESET_TRACES>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  const body = await actionsRequest<T>(
    {
      payload,
      type: ACTION_TYPE.RESET_TRACES
    },
    signal
  )

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}
